// extracted by mini-css-extract-plugin
export default {"account_form":"styles_account_form__ektB1","signup_main":"styles_signup_main__QzmI2","signup_area":"styles_signup_area__mF7YO","hide_button":"styles_hide_button__i1Ccr"};